/**
 * MapEmptyState — shown when no map data is available.
 */

import React from 'react';

interface MapEmptyStateProps {
  title?: string;
  description?: string;
  action?: { label: string; onClick: () => void };
}

export default function MapEmptyState({
  title = 'No map data',
  description = 'Add farmers, field boundaries, or warehouses with GPS coordinates to see them on the map.',
  action,
}: MapEmptyStateProps) {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-slate-50/80 backdrop-blur-sm z-10 pointer-events-none">
      <div className="text-center max-w-xs pointer-events-auto">
        <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-slate-100 flex items-center justify-center">
          <svg className="w-8 h-8 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
          </svg>
        </div>
        <h3 className="text-sm font-bold text-slate-700">{title}</h3>
        <p className="text-xs text-slate-500 mt-1">{description}</p>
        {action && (
          <button
            onClick={action.onClick}
            className="mt-3 px-4 py-2 bg-emerald-600 text-white text-xs font-semibold rounded-lg hover:bg-emerald-700 transition-colors"
          >
            {action.label}
          </button>
        )}
      </div>
    </div>
  );
}
